import StringUtils from "util/StringUtils";
import ViewTypeLabel from "views/components/ViewTypeLabel";
import { formatDefinition } from "views/components/export/ExportStrategy";
const getFilename = (view, selectedWidget) => {
  let filename = "search-result";
  if (selectedWidget) {
    const widgetTitle = view.getWidgetTitleByWidget(selectedWidget);
    filename = `${widgetTitle}-${filename}`;
  } else {
    const viewTitle = view.title || `Untitled ${ViewTypeLabel({ type: view.type, capitalize: true })}`;
    filename = `${viewTitle}-${filename}`;
  }
  return StringUtils.replaceSpaces(filename, "-");
};
const startDownload = (format, downloadFile, view, executionState, selectedWidget, selectedFields, limit, customSettings, currentUser, currentQuery) => {
  const { formatSpecificFileDownloader } = formatDefinition(format);
  const payload = {
    execution_state: executionState,
    fields_in_order: selectedFields.map((field) => field.field),
    limit,
    ...customSettings
  };
  const searchType = selectedWidget ? view.getSearchTypeByWidgetId(selectedWidget.id) : void 0;
  const filename = getFilename(view, selectedWidget);
  if (typeof formatSpecificFileDownloader === "function") {
    return formatSpecificFileDownloader(
      format,
      selectedWidget,
      view,
      executionState,
      currentUser,
      currentQuery,
      payload
    );
  }
  return downloadFile(format, payload, view.search.queries, searchType, view.search.id, filename);
};
export default startDownload;
